export const USER_ROLES = [
  {
    label: 'Admin',
    color: 'purple',
  },
];

export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
